import React from "react";
import { useNavigate } from "react-router-dom";
import { MissionSubCard, MissionSubCardHorizontalDivider } from "./MissionLayoutComponents";


import Button from "../../common_components/Button";



function MissionRejected({ mission, userMissionState, refreshMissionStatus }) {
    const navigate = useNavigate();

    return (
        <MissionSubCard>
            <div className="mission-complete-container">
                <div className="mission-content-card-text">
                    Unfortunately, you are not the target audience for this mission.
                </div>
                <Button size="medium" color="gray" onClick={() => navigate("/missions")}>Back to missions</Button>
            </div>
        </MissionSubCard>
    )
}

export default MissionRejected;